import { api } from './auth.service';
import type { CreateUserDTO } from '@/types/user';

export const saveFcmToken = async (authId: string, token: string) => {
    return api.post('/users/fcm-token', { authId, token });
};

export const fetchDbUser = async (authId: string, email: string, provider: 'firebase' | 'rsync' = 'firebase') => {
    const res = await api.post('/users/auth', { authId, email, provider });
    return res.data;
};

export const createUser = async (userData: CreateUserDTO) => {
    const res = await api.post('/users', userData);
    return res.data;
};
